import React, { Fragment, useMemo } from 'react';
import DataGrid from 'components/DataGrid';
import DataGridColumnHeader from 'components/DataGridColumnHeader';
import FormikFields from 'components/FormikFields';
import SearchAndFilters from 'components/SearchAndFilters';
import useFilters from 'hooks/useFilters';
import { useQuery } from '@tanstack/react-query';
import services from 'services';

const ExampleFullTableQueryPage = () => {
  const { filters, sorting, handleSorting, handleSearch, resetFilterToInitial } = useFilters({
    page: 0,
    pageSize: 10,
    name: '',

    sortField: '',
    sortDirection: '',
  });
  const { data, isLoading } = useQuery({
    queryKey: ['example-todos'],
    queryFn: async () => {
      const response = await services.get('https://jsonplaceholder.typicode.com/todos?_limit=20');
      return response?.data;
    },
  });

  const columns = useMemo(() => {
    return [
      {
        header: ({ column }) => <DataGridColumnHeader column={column} title={'ID'} />,
        accessorKey: 'id',
      },
      {
        header: 'Title',
        accessorKey: 'title',
      },
    ];
  }, []);

  return (
    <div className='component:ExampleFullTableQueryPage'>
      <code>{JSON.stringify({ filters })}</code>

      <SearchAndFilters
        initialValues={filters}
        classNameContainer='tw-mb-3'
        classNameButtonContainer='align-self-end'
        renderFilter={({ propsFormik }) => {
          return (
            <Fragment>
              <FormikFields.Input name='name' label='Name' placeholder='Search by name...' />
            </Fragment>
          );
        }}
        onResetSearch={({ resetForm }) =>
          () => {
            resetForm();
            resetFilterToInitial();
          }}
        onSubmitSearch={(values) => {
          handleSearch(values);
        }}
      />

      <DataGrid
        dataSource={{
          isFetching: isLoading,
          data: data || [],
        }}
        columns={columns}
        manualControl={{
          sorting: sorting,
          setSorting: handleSorting,
        }}
        hideColumnView
      />
    </div>
  );
};

export default ExampleFullTableQueryPage;
